import React from 'react'

import { SxProps } from '@mui/material'
import { TReportBlock } from 'types/GlobalReport'
import { TCommentThreadData } from 'types/GlobalComment'
import { CustomPeriodFilter, PeriodFilter } from 'types/GlobalWidget'

import Box from 'components_new/atoms/Box'

import DndBlocks from 'components_new/molecules/DndBlocks'
import ReportWidget from 'components_new/organisms/ReportWidget'

type ReportBlockProps = {
  activeFilters: Record<string, string[]>
  block: TReportBlock
  editMode: boolean
  locked?: boolean
  onAddComment?: (widgetId: string, data: TCommentThreadData) => void
  onAddWidget?: () => void
  onReorderWidgets?: (newOrder: string[]) => void
  periodFilter?: PeriodFilter | CustomPeriodFilter
  sx?: SxProps
  variant: 'edition' | 'template'
}

const ReportBlock = (props: ReportBlockProps) => {
  const {
    activeFilters,
    block,
    editMode,
    locked,
    onAddComment,
    onAddWidget,
    onReorderWidgets,
    periodFilter,
    sx,
    variant
  } = props

  const widgetItems = block.widgets.map((refWidget) => ({
    content: (
      <ReportWidget
        activeFilters={activeFilters}
        editionId={block.report_edition_id}
        editMode={editMode}
        id={refWidget.id}
        locked={locked}
        onAddComment={onAddComment}
        periodFilter={periodFilter}
        reportId={block.report_id}
        variant={variant}
      />
    ),
    id: refWidget.id
  }))

  return (
    <Box
      sx={{
        display: 'flex',
        gap: editMode && variant === 'template' ? 0 : 2,
        minWidth: 0,
        width: '100%',
        ...sx
      }}
    >
      {editMode && variant === 'template' ? (
        <DndBlocks
          addBlock={
            onAddWidget
              ? {
                  onClick: onAddWidget
                }
              : undefined
          }
          editable={editMode}
          handleDragEnd={onReorderWidgets ?? (() => {})}
          items={widgetItems}
          orientation="horizontal"
          sx={{ flex: 1 }}
        />
      ) : (
        widgetItems.map((widget) => widget.content)
      )}
    </Box>
  )
}

export default ReportBlock
